import React, { useState } from "react";
import Navbar from "./Navbar";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaInstagram,
  FaCheck,
  FaCopy,
  FaClock,
  FaShieldAlt,
} from "react-icons/fa";
import SEO from "../components/SEO";

const HOURS = [
  { day: "Monday – Saturday", time: "09:00 AM – 08:00 PM", status: "Open" },
  { day: "Sunday", time: "10:00 AM – 06:00 PM", status: "By Appointment" },
];

export default function ContactUs() {
  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = (e, text, field) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2200);
  };

  return (
    <div
      style={{
        backgroundColor: "#FBFBFA",
        color: "#1E293B",
        fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
      }}
      className="min-vh-100"
    >
      <SEO
        title="Contact FlawSkin | Direct Clinical Inquiries & Bookings"
        description="Connect with FlawSkin Private Limited. Schedule consultations, request patch tests, or contact our clinical team via WhatsApp, phone, or email."
        canonical="https://flawskin.com/contact"
      />
      <Navbar />

      {/* Hero Header */}
      <section
        className="py-5 border-bottom border-light-subtle position-relative overflow-hidden"
        style={{
          background: "linear-gradient(180deg, #F8FAFC 0%, #F1F5F9 100%)",
        }}
      >
        <div
          className="position-absolute rounded-circle opacity-50"
          style={{
            width: "500px",
            height: "500px",
            background:
              "radial-gradient(circle, rgba(13,148,136,0.09) 0%, transparent 70%)",
            top: "-160px",
            left: "50%",
            transform: "translateX(-50%)",
            filter: "blur(60px)",
            pointerEvents: "none",
          }}
        />

        <div className="container py-lg-4 text-center position-relative">
          <div
            className="d-inline-flex align-items-center gap-2 px-3 py-1.5 rounded-pill mb-4 border"
            style={{ backgroundColor: "#FFFFFF", borderColor: "#E2E8F0" }}
          >
            <span
              className="badge rounded-pill"
              style={{
                backgroundColor: "#8dcae4",
                color: "#FFFFFF",
                fontSize: "0.72rem",
              }}
            >
              DIRECT DESK
            </span>
            <span className="text-secondary small fw-medium">
              Confidential Consultations
            </span>
          </div>

          <h1
            className="display-4 fw-bolder tracking-tight mb-3"
            style={{ color: "#0F172A", letterSpacing: "-0.03em" }}
          >
            Speak With Our <br />
            <span style={{ color: "#8dcae4" }}>Clinical Care Team</span>
          </h1>

          <p
            className="lead mx-auto mb-0"
            style={{
              maxWidth: "620px",
              color: "#475569",
              lineHeight: "1.7",
              fontSize: "1.1rem",
            }}
          >
            Whether you are booking a patch test, mapping treatment areas, or
            seeking advice on laser suitability, our specialists are accessible
            across multiple direct channels.
          </p>
        </div>
      </section>

      {/* Main Structural Layout */}
      <section className="py-5">
        <div className="container py-lg-3">
          <div className="row g-4 align-items-stretch">
            {/* Left Column: Direct Communication Cards */}
            <div className="col-12 col-lg-7 d-flex flex-column gap-3">
              {/* WhatsApp Priority Conversion Card */}
              <div
                className="p-4 rounded-4 border shadow-sm transition position-relative"
                style={{
                  backgroundColor: "#FFFFFF",
                  borderColor: "#CCFBF1",
                  borderLeft: "6px solid #8dcae4",
                }}
              >
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-3 p-3 d-inline-flex"
                      style={{ backgroundColor: "#ECFDF5", color: "#059669" }}
                    >
                      <FaWhatsapp size={26} />
                    </div>
                    <div>
                      <div className="d-flex align-items-center gap-2">
                        <h2
                          className="h6 fw-bold mb-0"
                          style={{ color: "#0F172A" }}
                        >
                          Fast-Track on WhatsApp
                        </h2>
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor: "#DCFCE7",
                            color: "#166534",
                            fontSize: "0.68rem",
                            fontWeight: "600",
                          }}
                        >
                          FASTEST RESPONSE
                        </span>
                      </div>
                      <p
                        className="small mb-0 mt-1"
                        style={{ color: "#64748B" }}
                      >
                        Instant chat for pricing, package queries, and photo
                        consultations.
                      </p>
                    </div>
                  </div>
                  <a
                    href="https://wa.me/917892644030?text=Hello%20Flawskin%2C%20I%20would%20like%20to%20inquire%20about%20laser%20hair%20removal."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn px-4 py-2 rounded-3 fw-semibold small text-white text-nowrap w-100 w-sm-auto text-center"
                    style={{ backgroundColor: "#059669", border: "none" }}
                  >
                    Start Chat
                  </a>
                </div>
              </div>

              {/* Direct Phone Call Card */}
              <div
                className="p-4 rounded-4 bg-white border shadow-sm"
                style={{ borderColor: "#E2E8F0" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <a
                    href="tel:+917892644030"
                    className="d-flex align-items-center gap-3 text-decoration-none"
                    style={{ color: "inherit" }}
                  >
                    <div
                      className="rounded-3 p-3 d-inline-flex"
                      style={{ backgroundColor: "#F0FDFA", color: "#8dcae4" }}
                    >
                      <FaPhoneAlt size={20} />
                    </div>
                    <div>
                      <span
                        className="text-uppercase fw-bold d-block"
                        style={{
                          fontSize: "0.7rem",
                          letterSpacing: "0.06em",
                          color: "#8dcae4",
                        }}
                      >
                        Clinical Help Desk
                      </span>
                      <span
                        className="fs-8 fw-bold"
                        style={{ color: "#0F172A" }}
                      >
                        +91 78926 44030
                      </span>
                    </div>
                  </a>

                  <button
                    onClick={(e) => handleCopy(e, "+917892644030", "phone")}
                    className="btn btn-sm btn-light border rounded-2 d-inline-flex align-items-center gap-1.5 px-3 py-1.5"
                    style={{ color: "#475569", borderColor: "#CBD5E1" }}
                    title="Copy phone number"
                  >
                    {copiedField === "phone" ? (
                      <>
                        <FaCheck size={12} className="text-success" />
                        <span className="small fw-semibold text-success">
                          Copied
                        </span>
                      </>
                    ) : (
                      <>
                        <FaCopy size={12} />
                        <span className="small fw-medium">Copy</span>
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Email Support Card */}
              <div
                className="p-4 rounded-4 bg-white border shadow-sm"
                style={{ borderColor: "#E2E8F0" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <a
                    href="mailto:Contact@flawskin.com"
                    className="d-flex align-items-center gap-3 text-decoration-none"
                    style={{ color: "inherit" }}
                  >
                    <div
                      className="rounded-3 p-3 d-inline-flex"
                      style={{ backgroundColor: "#F8FAFC", color: "#475569" }}
                    >
                      <FaEnvelope size={20} />
                    </div>
                    <div>
                      <span
                        className="text-uppercase fw-bold d-block"
                        style={{
                          fontSize: "0.7rem",
                          letterSpacing: "0.06em",
                          color: "#64748B",
                        }}
                      >
                        Official Email
                      </span>
                      <span
                        className="fs-8 fw-bold"
                        style={{ color: "#0F172A" }}
                      >
                        Contact@flawskin.com
                      </span>
                    </div>
                  </a>

                  <button
                    onClick={(e) =>
                      handleCopy(e, "Contact@flawskin.com", "email")
                    }
                    className="btn btn-sm btn-light border rounded-2 d-inline-flex align-items-center gap-1.5 px-3 py-1.5"
                    style={{ color: "#475569", borderColor: "#CBD5E1" }}
                    title="Copy email address"
                  >
                    {copiedField === "email" ? (
                      <>
                        <FaCheck size={12} className="text-success" />
                        <span className="small fw-semibold text-success">
                          Copied
                        </span>
                      </>
                    ) : (
                      <>
                        <FaCopy size={12} />
                        <span className="small fw-medium">Copy</span>
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Maps & Navigation Card */}
              <a
                href="https://maps.app.goo.gl/xoWjuJowYrRgs6nWA"
                target="_blank"
                rel="noopener noreferrer"
                className="p-4 rounded-4 bg-white border shadow-sm text-decoration-none d-flex justify-content-between align-items-center"
                style={{ borderColor: "#E2E8F0", color: "inherit" }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="rounded-3 p-3 d-inline-flex"
                    style={{ backgroundColor: "#FEF3C7", color: "#D97706" }}
                  >
                    <FaMapMarkerAlt size={20} />
                  </div>
                  <div>
                    <span
                      className="text-uppercase fw-bold d-block"
                      style={{
                        fontSize: "0.7rem",
                        letterSpacing: "0.06em",
                        color: "#D97706",
                      }}
                    >
                      Physical Headquarters
                    </span>
                    <span className="fw-bold" style={{ color: "#0F172A" }}>
                      Navigate on Google Maps
                    </span>
                    <span className="d-block small text-muted">
                      Tap to view clinic directions & parking
                    </span>
                  </div>
                </div>
                <div
                  className="btn btn-sm btn-light border rounded-pill px-3 py-1 fw-semibold small"
                  style={{ color: "#0F172A", borderColor: "#CBD5E1" }}
                >
                  Open Maps →
                </div>
              </a>
            </div>

            {/* Right Column: Schedule, Socials, & Safety Commitments */}
            <div className="col-12 col-lg-5">
              <div
                className="p-4 p-md-5 rounded-4 bg-white border shadow-sm h-100 d-flex flex-column justify-content-between"
                style={{ borderColor: "#E2E8F0" }}
              >
                <div>
                  {/* Hours Block */}
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <FaClock size={16} style={{ color: "#8dcae4" }} />
                    <h3
                      className="h6 fw-bold mb-0 text-uppercase"
                      style={{
                        color: "#0F172A",
                        letterSpacing: "0.05em",
                        fontSize: "0.85rem",
                      }}
                    >
                      Clinical Operating Hours
                    </h3>
                  </div>

                  <div
                    className="rounded-3 border overflow-hidden mb-4"
                    style={{ borderColor: "#E2E8F0" }}
                  >
                    {HOURS.map((slot, index) => (
                      <div
                        key={index}
                        className={`p-3 d-flex justify-content-between align-items-center ${
                          index < HOURS.length - 1 ? "border-bottom" : ""
                        }`}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#F8FAFC" : "#FFFFFF",
                        }}
                      >
                        <div>
                          <div
                            className="fw-semibold small"
                            style={{ color: "#0F172A" }}
                          >
                            {slot.day}
                          </div>
                          <div
                            className="text-muted"
                            style={{ fontSize: "0.75rem" }}
                          >
                            {slot.time}
                          </div>
                        </div>
                        <span
                          className="badge rounded-pill px-2.5 py-1"
                          style={{
                            backgroundColor:
                              slot.status === "Open" ? "#DCFCE7" : "#F1F5F9",
                            color:
                              slot.status === "Open" ? "#166534" : "#475569",
                            fontSize: "0.7rem",
                          }}
                        >
                          {slot.status}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Social Channel Connect */}
                  <h4 className="h6 fw-bold mb-2" style={{ color: "#0F172A" }}>
                    Clinical Case Studies & Insights
                  </h4>
                  <p
                    className="small mb-3"
                    style={{ color: "#64748B", lineHeight: "1.6" }}
                  >
                    Inspect documented before-and-after results, fluence
                    settings, and hygiene protocols on our verified Instagram.
                  </p>

                  <div className="d-flex gap-2 mb-4">
                    <a
                      href="https://www.instagram.com/flawskin_?igsh=MWpwMTViMzA4ajVqZA=="
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn border rounded-3 px-3 py-2 d-inline-flex align-items-center gap-2 small fw-semibold text-decoration-none shadow-xs"
                      style={{
                        backgroundColor: "#F8FAFC",
                        borderColor: "#E2E8F0",
                        color: "#0F172A",
                      }}
                    >
                      <FaInstagram size={18} style={{ color: "#E1306C" }} />
                      <span>@flawskin_</span>
                    </a>
                  </div>
                </div>

                {/* Hygiene & SLA Note */}
                <div
                  className="rounded-3 p-3 border mt-3"
                  style={{ backgroundColor: "#F8FAFC", borderColor: "#E2E8F0" }}
                >
                  <div className="d-flex gap-2">
                    <FaShieldAlt
                      size={16}
                      className="mt-1 flex-shrink-0"
                      style={{ color: "#8dcae4" }}
                    />
                    <div>
                      <div
                        className="fw-bold small"
                        style={{ color: "#0F172A" }}
                      >
                        Confidentiality Guarantee
                      </div>
                      <p
                        className="mb-0 text-muted"
                        style={{ fontSize: "0.78rem", lineHeight: "1.5" }}
                      >
                        All queries, medical skin profiles, and treatment
                        histories are managed strictly in-house under
                        confidentiality protocols.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pre-Appointment Checklist Strip */}
      <section className="py-4 bg-white border-top border-bottom">
        <div className="container">
          <div className="row g-3 align-items-center justify-content-between">
            <div className="col-12 col-md-4">
              <span
                className="text-uppercase fw-bold"
                style={{
                  fontSize: "0.72rem",
                  letterSpacing: "0.08em",
                  color: "#8dcae4",
                }}
              >
                Preparing for your session
              </span>
              <h4 className="h6 fw-bold mb-0 mt-1" style={{ color: "#0F172A" }}>
                Before You Reach Out:
              </h4>
            </div>
            <div className="col-12 col-md-8">
              <div className="d-flex flex-wrap gap-3 small text-secondary">
                <div className="d-flex align-items-center gap-1.5">
                  <span
                    className="badge rounded-circle p-1"
                    style={{ backgroundColor: "#8dcae4" }}
                  ></span>
                  <span>Avoid waxing or plucking 3 weeks prior</span>
                </div>
                <div className="d-flex align-items-center gap-1.5">
                  <span
                    className="badge rounded-circle p-1"
                    style={{ backgroundColor: "#8dcae4" }}
                  ></span>
                  <span>
                    Share any active topical retinoids or sun exposure
                  </span>
                </div>
                <div className="d-flex align-items-center gap-1.5">
                  <span
                    className="badge rounded-circle p-1"
                    style={{ backgroundColor: "#8dcae4" }}
                  ></span>
                  <span>Shave target area 24 hours in advance</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Direct In-Home Call to Action */}
      <section className="py-5" style={{ backgroundColor: "#0F172A" }}>
        <div className="container py-lg-3 text-center">
          <h2
            className="h3 fw-bold text-white mb-2"
            style={{ letterSpacing: "-0.02em" }}
          >
            Ready to Schedule a Test Patch?
          </h2>
          <p
            className="mx-auto mb-4"
            style={{ maxWidth: "500px", color: "#94A3B8", fontSize: "0.95rem" }}
          >
            Experience the contact-cooling diode laser on a small patch of skin
            to confirm zero irritation and total comfort.
          </p>
          <a
            href="https://wa.me/917892644030?text=Hi%2C%20I%20would%20like%20to%20book%20a%20patch%20test%20with%20Flawskin."
            target="_blank"
            rel="noopener noreferrer"
            className="btn px-4 py-2.5 rounded-3 fw-semibold text-dark shadow-sm"
            style={{ backgroundColor: "#5EEAD4", border: "none" }}
          >
            Book Trail Session
          </a>
        </div>
      </section>
    </div>
  );
}
